export default {
  NOT: 0,
  WHOLE: 1,
  PART: 2,
};
